import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PhysicianAdvisorListItem } from '../../../../models/api/view/claim/details/case-management/physician-advisor-list-response';
import { LinkLabelComponent } from '../../../core/labels/link-label.component';
import { ProgressbarComponent } from '../../../core/labels/progressbar.component';
import { EmptyStateComponent } from '../../../core/panels/empty-state.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

@Component({
  selector: 'app-case-peer-review-list',
  imports: [
    TableComponent,
    ColumnComponent,
    EmptyStateComponent,
    ProgressbarComponent,
    LinkLabelComponent,
  ],
  template: `
    @if (loading) {
      <app-empty-state
        height="300px"
        icon="fa-light fa-user-doctor"
        label="Loading Physician/Peer Review"
        message="Retrieving physician advisor list"
      >
        <div class="tw-py-4">
          <app-progressbar />
        </div>
      </app-empty-state>
    } @else {
      <app-table
        [dataSource]="dataSource"
        [pageSize]="10"
        [scrollable]="false"
        recordLabel="Physician/Peer Review"
        [stripedRows]="false"
      >
        <app-column label="Service" name="serviceName">
          <ng-template let-data>
            <app-link-label (click)="onRowClick(data)">{{
              data.serviceName
            }}</app-link-label>
          </ng-template>
        </app-column>
        <app-column name="type" label="Type" />
        <app-column name="vendor" label="Vendor" />
        <app-column name="status" label="Status" />
        <app-column name="assignedTo" label="Assigned To" />
        <app-column name="referralReasons" label="Referral Reason">
          <ng-template let-data>
            {{ data.referralReasons?.join(', ') }}
          </ng-template>
        </app-column>
        <app-column name="dateSent" label="Date Sent" format="d" />
        <app-column name="receivedDate" label="Received Date" format="d" />
        <app-column name="dueDate" label="Due Date" format="d" />
        <app-column name="outcomes" label="Outcome">
          <ng-template let-data>
            {{ data.outcomes?.join(', ') }}
          </ng-template>
        </app-column>
      </app-table>
    }
  `,
  styles: [],
})
export class CasePeerReviewListComponent {
  @Input() dataSource: PhysicianAdvisorListItem[] = [];
  @Input() loading = false;
  @Output() rowSelected = new EventEmitter<PhysicianAdvisorListItem>();

  onRowClick(data: PhysicianAdvisorListItem): void {
    this.rowSelected.emit(data);
  }
}
